module.exports = __webpack_public_path__ + "6997337887698e8dc4bdc02df3e29122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/logo_login.png
// module id = 225
// module chunks = 0